var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.waitLoading),expression:"waitLoading"}],staticClass:"sso-login",attrs:{"element-loading-text":"跳转登录中...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('p',[_vm._v(_vm._s(_vm.errorMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }